import { TextInput, TextInputProps } from 'react-admin';
import { useInputWithPolicies } from './useInputWithPolicies';
import { IAccessLevel } from '../../shared/utils/policyCheck';

export type CommonTextInputProps = {
  classes?: {
    labelRoot?: any;
    formHelperTextRoot?: any;
  };
  ignorePolicies?: boolean;
} & TextInputProps &
  IAccessLevel;

const CommonTextInput = (props: CommonTextInputProps) => {
  const {
    variant,
    classes,
    InputProps = {},
    InputLabelProps = {},
    FormHelperTextProps = {},
    ...rest
  } = props;

  return useInputWithPolicies(
    <TextInput
      variant={variant || 'outlined'}
      InputProps={{
        ...InputProps,
      }}
      InputLabelProps={{
        ...InputLabelProps,
      }}
      FormHelperTextProps={{
        ...FormHelperTextProps,
      }}
      {...rest}
    />,
    props.source,
    props.level,
    props.ignorePolicies
  );
};

export default CommonTextInput;
